export default __webpack_public_path__ + "static/media/silver-wheel.37f511c1.png";